import React, { useState, useContext, useEffect } from 'react';
import axiosInstance from '../utils/axios-instance';
import Loginlogo from "../assets/login-page-logo.png";
import {AuthContext} from "../providers/auth-provider";
import { useNavigate } from "react-router-dom";
import UseAuth from "../utils/use-auth";
import { toast } from "sonner";
import { FiEye, FiEyeOff } from "react-icons/fi";

const ChangePassword = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);
    const { HandleUserLogOut } = UseAuth();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    //if there is no user, redirect to login page
    useEffect(() => {
        if (!user) {
          navigate("/login");
        }
    }, [user, navigate]);

    const validatePassword = (value) => {
        if (!value) return 'Password is required';
        if (value.length < 6) return 'Password must be at least 6 characters';
        return '';
    };

    const validateConfirmPassword = (password, confirmPassword) => {
        if (!confirmPassword) return 'Please confirm your password';
        if (password !== confirmPassword) return 'Passwords do not match';
        return '';
    };

    const handleRegister = async (e) => {
        e.preventDefault();

        const passwordError = validatePassword(password);
        const confirmPasswordError = validateConfirmPassword(password, confirmPassword);

        if (passwordError || confirmPasswordError) {
            setErrors({
                ...(passwordError && { password: passwordError }),
                ...(confirmPasswordError && { confirmPassword: confirmPasswordError }),
            });
            return;
        }

        setErrors({});
        setLoading(true);

        const data = {
            email : user.email,
            password: password,
        }
        
        try {
            const res = await axiosInstance.post('/auth/changepassword', data);
            if (res.status === 200) {
                toast.success("Password changed successfully!");
                //log the user out 
                HandleUserLogOut(); 
            } else {
                toast.error("Error changing password");
            }
        } catch (err) {
            toast.error("Error changing password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 px-4">
  <div className="max-w-lg w-full p-14 bg-white dark:bg-gray-800 rounded-xl shadow-md dark:shadow-gray-900/20 space-y-6">
    <img
      className="w-[100px] h-[80px] cursor-pointer mx-auto"
      src={Loginlogo}
      alt="Login logo"
    />
    <h2 className="text-xl font-bold text-center dark:text-white">Reset your password</h2>

    <form onSubmit={handleRegister}>
      <div className="mb-4 w-full">
        <label className="block font-medium mb-1 dark:text-gray-300">Password</label>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleRegister(e);
              }
            }}
            className={`w-full px-3 py-2 border ${
              errors.password ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'
            } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white`}
          />
          <span
            className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500 dark:text-gray-400"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
          </span>
        </div>
        {errors.password && (
          <p className="text-red-500 text-sm mt-1">{errors.password}</p>
        )}
      </div>

      <div className="mb-4 w-full">
        <label className="block font-medium mb-1 dark:text-gray-300">Confirm Password</label>
        <div className="relative">
          <input
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleRegister(e);
              }
            }}
            className={`w-full px-3 py-2 border ${
              errors.confirmPassword ? 'border-red-500' : 'border-gray-300 dark:border-gray-600'
            } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white`}
          />
          <span
            className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500 dark:text-gray-400"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
          </span>
        </div>
        {errors.confirmPassword && (
          <p className="text-red-500 text-sm mt-1">{errors.confirmPassword}</p>
        )}
      </div>

      <button
        type="submit"
        className="w-full bg-brandPrimary text-white py-2 rounded-lg font-semibold hover:bg-[#1e1b55] transition"
        disabled={loading}
      >
        {loading ? 'Resetting' : 'Reset'}
      </button>
    </form>
  </div>
</div>
    );
};

export default ChangePassword;